import { $fetch } from 'ofetch';
import type { $Fetch, FetchOptions } from 'ofetch';
import { defineNuxtPlugin } from '#app';
import { createApolloClient } from '../utils/apollo';
import type { IApiInstance } from '../types/api';
import GalleryModule from '../repository/modules/gallery';
import UserPaintsModule from '../repository/modules/userPaints';

export default defineNuxtPlugin(() => {
  const {
    public: {
      backendUrl,
      xAppName,
      sportsGqlUrl,
      paintForClubBackendUrl,
    },
  } = useRuntimeConfig();

  const gqlBackendUrl = backendUrl + '/graphql';

  const fetchOptionsCyber: FetchOptions = {
    baseURL: sportsGqlUrl,
  };

  /** create a new instance of $fetcher with custom option */
  // const apiFetcherMain = $fetch.create(fetchOptionsMain);
  const apiFetcherCyber = $fetch.create(fetchOptionsCyber);

  const apiFetcherPaint: $Fetch = $fetch.create({
    baseURL: paintForClubBackendUrl || 'https://specials.sports.ru/paint-for-club-backend/',
    credentials: 'include',
    retry: 0,
  } as FetchOptions);

  const apiFetcherAkinfeev: $Fetch = $fetch.create({
    baseURL: 'https://specials.sports.ru/akinfeev-backend/',
    credentials: 'include',
    retry: 0,
  } as FetchOptions);

  const apolloClientMain = createApolloClient({
    httpLinkOptions: {
      uri: gqlBackendUrl,
      credentials: 'include',
      headers: {
        'x-appname': xAppName,
      },
    },
  });

  /** an object containing all repositories we need to expose */
  const modules: IApiInstance = {
    client: apolloClientMain,
    gallery: new GalleryModule(apiFetcherPaint),
    userPaints: new UserPaintsModule(apiFetcherAkinfeev),
  };

  return {
    provide: {
      api: modules,
    },
  };
});
